import CustomModal from '@/components/shared/CustomModal/CustomModal'
import ModalBody from '@/components/shared/CustomModal/ModalBody'
import ModalFooter from '@/components/shared/CustomModal/ModalFooter'
import ModalHeader from '@/components/shared/CustomModal/ModalHeader'

export const CopyRunsheet = ({
    copyRunsheetModal,
    modalHandler,
    submitCopy,
    newRunsheetName,
    setNewRunsheetName,
    copyTract,
    setCopyTract,
    copyChaining,
    setCopyChaining,
}) => {
    
    const handleChainingToggle = () => setCopyChaining(prev => !prev)
    const handleTractToggle = () => setCopyTract(prev => !prev)
    
    return (
        <CustomModal open={copyRunsheetModal} modalHandler={modalHandler}>
            <form action="submit" onSubmit={submitCopy}>
                <ModalHeader>
                    Copy Runsheet
                </ModalHeader>
                
                <ModalBody>
                    <div className="flex flex-col gap-4">
                        <div className="flex flex-col">
                            <label htmlFor="runsheetName" className="text-sm font-semibold">New Runsheet Name</label>
                            <input
                                id="runsheetName"
                                type="text"
                                className="input w-full p-2 mt-1"
                                value={newRunsheetName}
                                onChange={e => setNewRunsheetName(e.target.value)}
                                required/>
                        </div>
                        
                        <div className="flex gap-2 items-center">
                            <input
                                type="checkbox"
                                className="checkbox"
                                checked={copyChaining}
                                name="chaining"
                                id="chaining"
                                onChange={handleChainingToggle}/>
                            <label htmlFor="chaining">Chaining</label>
                        </div>
                        
                        <div className="flex gap-2 items-center">
                            <input
                                type="checkbox"
                                className="checkbox"
                                checked={copyTract}
                                name="tracts"
                                id="tracts"
                                onChange={handleTractToggle}/>
                            <label htmlFor="tracts">Copy Tracts</label>
                        </div>
                    </div>
                </ModalBody>
                
                <ModalFooter>
                    <button type="submit" className="btn btn-active btn-accent">
                        Copy
                    </button>
                </ModalFooter>
            </form>
        </CustomModal>
    )
}